import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Toolbar from '../../common/Toolbar';
import ProductFilter from '../../filters/ProductFilter';
import styles from './DropshipProducts.module.scss';
import ActionLinkTop from '../../common/ActionLinkTop';
import ThemeFilterRetailer from '../../../components/theme/ThemeFilterRetailer';
import Search from '../../common/Search';
import ThemeRetailer from '../../../components/theme/ThemeRetailer';
import WrapperColumnRetailers from '../../../components/grid-container/WrapperColumnRetailers';
import DropshipProductCard from '../../common/DropshipProductCard';
import DropDownFilter from '../../filters/DropDownFilter';
import Button from '../../common/Button';
import Wall from '../../common/Wall';
import Spinner from '../../common/Spinner';
import { StaticFilters } from '../../../constants/staticFilters';

function DropshipProducts(props) {
  const onCheckProduct = (checked, value) => {
    const { check, uncheck } = props;

    if (checked) {
      check(value);
    } else {
      uncheck(value);
    }
  };

  const isChecked = (model) => props.checked.hasOwnProperty(model);

  const handlePageClick = (data) => {
    const { perPage, setPage } = props;
    setPage(perPage * data.selected);
  };

  const selectAllOnPage = () => {
    const selected = {};
    props.data.forEach((item) => {
      selected[item.model] = item.variants;
    });
    props.selectAllOnPage(selected);
  };

  const products = () => {
    if (props.isLoading) {
      return <Spinner />;
    }

    return props.data.map((item) => (
      <ThemeRetailer key={item.model}>
        <DropshipProductCard
          product={item}
          checkbox={!hasAutoSync}
          onCheck={onCheckProduct}
          checked={isChecked(item.model)}
          modal
          open={props.openModal}
          params={`/${props.supplierId}`}
          retailerId={props.retailerId}
          slider={true}
        />
      </ThemeRetailer>
    ));
  };

  const approveButtons = () => (
    <>
      <Wall />
      <ActionLinkTop title="Select this page" onClick={selectAllOnPage} />
      <ActionLinkTop title="Select all" onClick={props.selectAll} />
      <ActionLinkTop title="Unselect all" onClick={props.unselectAll} />
      <Wall />
      <Button text="Approve" onClick={props.approveChecked} disabled={Object.keys(props.checked).length === 0} />
      <Button
        margin_left
        color="white"
        text="Revoke"
        onClick={props.unapproveChecked}
        disabled={Object.keys(props.checked).length === 0}
      />
    </>
  );

  const actionLinks = () => {
    const approvedBrands = props.brands.filter((item) => !!item.approved_for_ecommerce);

    return (
      <>
        <Wall />
        <DropDownFilter values={approvedBrands} onChange={props.setSupplierId} images />
        {hasAutoSync ? null : approveButtons()}
      </>
    );
  };

  const hasAutoSync = useMemo(() => {
    const currentBrand = props.brands.find((brand) => brand.value === props.supplierId);
    return currentBrand ? currentBrand.auto_sync : false;
  }, [props.brands, props.supplierId]);

  const checkedCount = Object.keys(props.checked).length;

  return (
    <div className={styles.wrapperToolbar}>
      <Toolbar grow name={hasAutoSync ? 'Products on your website' : 'Sync products to your website'}>
        <div className={styles.right}>
          {checkedCount > 0 && (
            <span className={styles.selectedCount}>
              {checkedCount} {checkedCount === 1 ? 'Product' : 'Products'} Selected
            </span>
          )}
          {actionLinks()}
        </div>
      </Toolbar>
      <div className={styles.isHide}>
        <div className="row vertical-indent">
          <ThemeFilterRetailer>
            <Search searchQuery={props.searchQuery} search={props.productSearch} />

            <ProductFilter
              filters={props.filters}
              staticFilters={[StaticFilters.HAS_INVENTORY, StaticFilters.IS_RETAILER_APPROVED]}
              currentFilters={props.currentFilters}
              currentFilterSearches={props.currentFilterSearches}
              setFilter={props.setFilter}
              setFilterSearch={props.setFilterSearch}
              connectionHasAutoSync={hasAutoSync}
            />
          </ThemeFilterRetailer>

          <WrapperColumnRetailers
            isLoadingProducts={props.isLoadingProducts}
            currentPage={props.offset / props.perPage}
            pageCount={props.pageCount}
            handlePageClick={handlePageClick}
          >
            {products()}
          </WrapperColumnRetailers>
        </div>
      </div>
    </div>
  );
}

export default DropshipProducts;

DropshipProducts.defaultProps = {
  check: undefined,
  uncheck: undefined,
  checked: {},
  isLoadingProducts: false,
};

DropshipProducts.propTypes = {
  perPage: PropTypes.number.isRequired,
  filters: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  pageCount: PropTypes.number.isRequired,
  approveChecked: PropTypes.func.isRequired,
  unapproveChecked: PropTypes.func.isRequired,
  productSearch: PropTypes.func.isRequired,
  check: PropTypes.func,
  uncheck: PropTypes.func,
  checked: PropTypes.object,
  setPage: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  offset: PropTypes.number.isRequired,
  brands: PropTypes.array.isRequired,
  setSupplierId: PropTypes.func.isRequired,
  selectAllOnPage: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
  unselectAll: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  isLoadingProducts: PropTypes.bool,
  supplierId: PropTypes.number.isRequired,
  retailerId: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
